// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table > :not(caption) > * > * {
  border-bottom-width: 0;
}

.botonera {
  border: 1px solid;
  border-radius: 5px;
  width: 140px;
  height: 35px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
}

.botonera .input {
  width: 70px;
  text-align: center;
}

td {
  vertical-align: middle !important;
}

.btn-icon {
  border: 0;
  background: transparent;
  font-size: 26px;
}

.btn-icon:hover {
  color: var(--color-principal);
  font-size: 26px;
  font-weight: bolder;
}

@media (min-width: 320px) and (max-width: 480px), (min-width: 481px) and (max-width: 768px) {
  .row {
    flex-direction: column;
    align-items: center;
  }
  .col-8 {
    width: 90%;
  }
  .col-4 {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/carrito/carrito.component.scss","webpack://./../../Universo%20Tunning/ecommerce/src/app/pages/carrito/carrito.component.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;ACDF;;ADGA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;ACAF;;ADEA;EACE,WAAA;EACA,kBAAA;ACCF;;ADEA;EACE,iCAAA;ACCF;;ADEA;EACE,SAAA;EACA,uBAAA;EACA,eAAA;ACCF;;ADCA;EACE,6BAAA;EACA,eAAA;EACA,mBAAA;ACEF;;ADGA;EAGE;IACE,sBAAA;IACA,mBAAA;ECFF;EDIA;IACE,UAAA;ECFF;EDIA;IACE,UAAA;ECFF;AACF","sourcesContent":["\n\n.table > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.botonera {\n  border: 1px solid;\n  border-radius: 5px;\n  width: 140px;\n  height: 35px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 20px;\n}\n.botonera .input {\n  width: 70px;\n  text-align: center;\n}\n\ntd {\n  vertical-align: middle !important;\n}\n\n.btn-icon {\n  border: 0;\n  background: transparent;\n  font-size: 26px;\n}\n.btn-icon:hover {\n  color: var(--color-principal);\n  font-size: 26px;\n  font-weight: bolder;\n}\n\n\n\n@media (min-width: 320px) and (max-width: 480px),\n(min-width: 481px) and (max-width: 768px) {\n\n  .row{\n    flex-direction: column;\n    align-items: center;\n  }\n  .col-8{\n    width: 90%;\n  }\n  .col-4{\n    width: 90%;\n  }\n}\n",".table > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n\n.botonera {\n  border: 1px solid;\n  border-radius: 5px;\n  width: 140px;\n  height: 35px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  font-size: 20px;\n}\n\n.botonera .input {\n  width: 70px;\n  text-align: center;\n}\n\ntd {\n  vertical-align: middle !important;\n}\n\n.btn-icon {\n  border: 0;\n  background: transparent;\n  font-size: 26px;\n}\n\n.btn-icon:hover {\n  color: var(--color-principal);\n  font-size: 26px;\n  font-weight: bolder;\n}\n\n@media (min-width: 320px) and (max-width: 480px), (min-width: 481px) and (max-width: 768px) {\n  .row {\n    flex-direction: column;\n    align-items: center;\n  }\n  .col-8 {\n    width: 90%;\n  }\n  .col-4 {\n    width: 90%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
